// extracted by mini-css-extract-plugin
var _1 = "ListItemAvatar-moduleavatar__RkZvj";
export { _1 as "avatar" }
